module.exports = __webpack_public_path__ + "static/media/arrow-down-error.727aa7e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-down-error.svg
// module id = 79
// module chunks = 0